import React from "react";
import Nicholas from "assets/Nicholas.png";

// form & validsation
import * as yup from "yup";
import { FormError, FormLabel, FormDropDown } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";
import Slider from "@material-ui/core/Slider";
import { employmentType } from "utils";

// schema
const schema = yup.object().shape({
  financial: yup
    .object()
    .shape({
      user_income: yup.string().required("You must provide a value"),
      user_employment_status: yup.string().required("You must provide a value"),
      partner_income: yup.string().required("You must provide a value"),
      partner_employment_status: yup
        .string()
        .required("You must provide a value"),
    })
    .required(),
});

const marks = [
  "$0 - $20,000",
  "$20,000 - $45,000",
  "$46,000 - $80,000",
  "$81,000 - $100,000",
  "$101,000 - $150,000",
  "$151,000 - $200,000",
  "$200,000+",
];

export function Step09({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });

  function valuetext(value, name) {
    setValue(name, value);
    return `${value}°C`;
  }
  const handleData = (values) => {
    const copy_data = Object.assign({}, store.financial);
    const merger_current_values = { ...copy_data, ...values.financial };
    const mergeToStore = { ...store, financial: merger_current_values };
    onSubmit(mergeToStore);
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="relationship.living_date"
            className={customClasses.questionText}
            error={errors?.relationship?.living_date?.message}
          >
            Your approximate income range (annual)
          </FormLabel>

          <article>
            {/* <Slider
							defaultValue={20}
							getAriaValueText={value => valuetext(value, 'financial.user_income')}
							aria-labelledby="discrete-slider-custom"
							step={7}
							valueLabelDisplay="auto"
							marks={marks}
							max={200000}
						/> */}
            <FormDropDown
              placeholder="Select Your Income Range"
              id="financial.user_income"
              type="text"
              name="financial.user_income"
              error={errors?.financial?.user_income?.message}
              register={register}
              data={marks}
              setValue={setValue}
              value={watch()?.financial?.user_income}
            />
          </article>
        </section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.user_employment_status"
            className={customClasses.questionText}
            error={errors?.financial?.user_employment_status?.message}
          >
            Your employment status
          </FormLabel>
          <article>
            <FormDropDown
              placeholder="Select Your Employment Status"
              id="financial.user_employment_status"
              type="text"
              name="financial.user_employment_status"
              error={errors?.financial?.user_employment_status?.message}
              register={register}
              data={employmentType}
              setValue={setValue}
              value={watch()?.financial?.user_employment_status}
            />
          </article>
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="relationship.living_date"
            className={customClasses.questionText}
            error={errors?.relationship?.living_date?.message}
          >
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}
            ’s approximate income range (annual)
          </FormLabel>

          <article>
            <FormDropDown
              placeholder="Select Partner Income Range"
              id="financial.partner_income"
              type="text"
              name="financial.partner_income"
              error={errors?.financial?.partner_income?.message}
              register={register}
              data={marks}
              setValue={setValue}
              value={watch()?.financial?.partner_income}
            />
          </article>
        </section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.partner_employment_status"
            className={customClasses.questionText}
            error={errors?.financial?.partner_employment_status?.message}
          >
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}
            ’s employment status
          </FormLabel>
          <article>
            <FormDropDown
              placeholder="Select Partner Employment Status"
              id="financial.partner_employment_status"
              type="text"
              name="financial.partner_employment_status"
              error={errors?.financial?.partner_employment_status?.message}
              register={register}
              data={employmentType}
              setValue={setValue}
              value={watch()?.financial?.partner_employment_status}
            />
          </article>
        </section>
      </section>
    </form>
  );
}
